( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '[data-component="multi-cta"]' ).forEach( ( component ) => {
        const links = component.querySelectorAll( 'a[data-hover]' );
        const images = component.querySelectorAll( '.fit-image' );

        if ( !images.length ) return;

        // Default active image (first one)
        let activeImage = images[0];

        function setActive( img, hovered = false ) {
          images.forEach( ( image ) => {
            image.classList.remove( 'is-active', 'is-hovered' );
          } );

          img.classList.add( 'is-active' );

          if ( hovered ) {
            img.classList.add( 'is-hovered' );
          }

          activeImage = img;
        }

        // ✅ Initialize
        setActive( activeImage );

        links.forEach( ( link ) => {
          const targetClass = link.dataset.hover;
          const targetImage = component.querySelector( `.fit-image.${targetClass}` );

          if ( !targetImage ) return;

          link.addEventListener( 'mouseenter', () => {
            setActive( targetImage, true );
          } );

          link.addEventListener( 'focus', () => {
            setActive( targetImage, true );
          } );

          link.addEventListener( 'mouseleave', () => {
            // keep last active, just remove hover styling
            setActive( activeImage );
          } );

          link.addEventListener( 'blur', () => {
            setActive( activeImage );
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'multi-cta', COMPONENT );
} )( app );
